import { ErrorBoundary } from '@sentry/react';
import {
    ReactSVG,
} from 'react-svg';
import iconLibrary from 'img/svg/icon-library.js';
import styled from 'styled-components';

const IconWrapper = styled(ReactSVG)`
    ${({ color }) => color && `
        svg {
            * {
                stroke: ${color} !important;
            }
        }
    `}
    ${({ fillcolor }) => fillcolor && `
        svg {
            * {
                fill: ${fillcolor} !important;
            }
        }
    `}
`;

// @NOTE svgs are not sanitized, some have stylesheets with classes that will override each other

function injectSvgTitle(svg, name, title) {
    svg.removeAttribute('id');
    svg.innerHTML = svg.innerHTML.replaceAll('st0', 'st0' + name);
    svg.innerHTML = svg.innerHTML.replaceAll('st1', 'st1' + name);
    svg.innerHTML = svg.innerHTML.replaceAll('st2', 'st2' + name);
    if (title) {
        const titleEl = document.createElementNS('http://www.w3.org/2000/svg', 'title');
        titleEl.textContent = title;
        const titleId = `icon-title-${name}`;
        titleEl.setAttribute('id', titleId);
        svg.insertBefore(titleEl, svg.firstChild);
        svg.setAttribute('role', 'img');
        svg.setAttribute('aria-labelledby', titleId);
    } else {
        svg.setAttribute('aria-hidden', 'true');
    }
}

function Icon({ className, color, fillColor, category, name, fallback, url, onClick, title }) {
    if (url) {
        return <ErrorBoundary>
            <IconWrapper
                color={color}
                fillcolor={fillColor}
                className={`Icon ${className || ''}`}
                src={url}
                onClick={onClick}
                beforeInjection={(svg) => injectSvgTitle(svg, name, title)} />
        </ErrorBoundary>
    } else if (iconLibrary[category] && iconLibrary[category][name]) {
        return <ErrorBoundary>
            <IconWrapper
                color={color}
                fillcolor={fillColor}
                className={`Icon ${className || ''}`}
                beforeInjection={(svg) => injectSvgTitle(svg, name, title)}
                src={iconLibrary[category][name]}
                onClick={onClick}
            />
        </ErrorBoundary>
    } else if (fallback) {
        return <>{fallback}</>
    }
    return null;
}

export default Icon
